import * as React from 'react';
import TransformView from '../TransformView/TransformView';
import { IScript } from '../../../../../models/IScript';
import { Environment } from '../../../../../const/environment';
import { useCallback, useEffect, useRef, useState } from 'react';
import InspectTransformPanel from '../../InspectTransformPanel/InspectTransformPanel';
import { HistoryIconSvg } from '../TransformIcons';
import { observer } from 'mobx-react';
import { IProject } from '../../../../../models/IProject';
import { transformsStore } from '../../../../../mobx/transforms.store';
import { getTransformFromText } from '../getTransformFromText';
import * as _ from 'lodash';
import scriptDraftService from '../../../../../services/ScriptDraftService';
import { Loader, LoaderSize, LoaderTheme } from '../../../../components/Loader/Loader';
import { Button, ButtonTheme } from '../../../../components/Button/Button';
import TransformConfig from '../TransformConfig/TransformConfig';

type TransformContainerProps = {
    script: IScript,
    project: IProject;
    scriptName: string,
    environment: Environment,
    isScriptsPanelCollapsed: boolean
    discardScriptsChangesTs: number
}



function TransformContainer({ environment, script, project, discardScriptsChangesTs, isScriptsPanelCollapsed }: TransformContainerProps) {

    const [isHistoryShown, setIsHistoryShown] = useState(false);

    useEffect(() => {
        async function getScriptDraft(script) {
            const scriptDraft = await scriptDraftService.getScriptText(script) || script.text;
            transformsStore.init(script, scriptDraft);
        }
        getScriptDraft(script);
    }, [script?.scriptId]);

    useEffect(() => {
        return () => {
            transformsStore.resetStore();
        };
    }, [script?.scriptId]);

    const prevUpdateTsRef = useRef<number>(script?.updateTs);

    useEffect(() => {
        if (!_.isEqual(prevUpdateTsRef.current, script?.updateTs)) {
            transformsStore.updateTransformAfterSaving();
            prevUpdateTsRef.current = script?.updateTs;
        }
    }, [script?.updateTs, transformsStore]);

    const openHistoryCb = useCallback(() => {
        setIsHistoryShown(true);
    }, []);

    const closeHistoryCb = useCallback(() => {
        setIsHistoryShown(false);
    }, []);


    const initTransform = transformsStore.transform;
    const savedTransform = getTransformFromText(script.text);
    const linesFilter = transformsStore.linesFilter;


    return <div className="transform-container">

        {transformsStore.wasInitialized ?
            <TransformView
                transformLabel="Transform"
                tableLabel="Examples"
                key={`${script.scriptId}-${JSON.stringify(linesFilter)}`}
                environment={environment}
                script={script}
                project={project}
                transform={initTransform}
                savedTransform={savedTransform}
                previewMode={false}
                linesFilter={linesFilter}
                withFilter={!!linesFilter?.length}
                scrollToLastRow={!!transformsStore.rowToCopy}
                isScriptsPanelCollapsed={isScriptsPanelCollapsed}
                onHistory={openHistoryCb}
            /> :
            <Loader size={LoaderSize.Medium} theme={LoaderTheme.Dark} />}
        {
            (script?.name && isHistoryShown) &&
            <InspectTransformPanel
                environment={environment}
                project={project}
                transformName={script?.name}
                onClose={closeHistoryCb}
            />
        }
    </div >;
}

export default observer(TransformContainer);
